import React from 'react'
import './brand.scss'

type size = {
    size?: string
}

const Brand = ({size}: size) => {
    return (
        <div className={
            'brand ' + 
            (size ? 'brand--small' : '')
        }>
            <img src="/images/chatbot-murphy.png" 
                alt="Murphy"
                className="brand__logo" />
        </div>
    )
}

export default Brand
